export type Optional<T> = T | undefined | null;

export enum NATIVE_EVENT_KEY {
  CONTINUE_PLAYING = 'continuePlaying',
  MEDIA_DETAIL = 'mediaDetail',
  ACCOUNT_MENU = 'accountMenu',
}

export enum CALLOUT_KEY {
  ACCOUNT_MENU_BUTTON = 'account-avatar-callout',
}

type NATIVE_EVENT_KEY_ID = `${NATIVE_EVENT_KEY}-${string}`;

export interface Link {
  href: string;
}

export interface BridgeAction {
  handler: string;
  command?: string;
  nativeEventKey?: NATIVE_EVENT_KEY | NATIVE_EVENT_KEY_ID;
  [key: string]: any;
}
